import styled from "styled-components";

export const AttendingEventsSection = styled.section`
  background: #ffffff;
  border-radius: 1.25rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1), 0 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06);
  padding: 1.8rem 2rem;
  border: 0.0625rem solid #F3F4F6;
  transition: all 0.2s ease-in-out;

`;

export const SectionTitle = styled.h3`
  margin: 0 0 0.9rem 0;
  font-size: 1.05rem;
  color: #fe2f67;
`;

export const AttendingEventsContainer = styled.div<{ $length: number; $seeAll: boolean; $visibleEvents: number }>`
  max-height: ${({ $seeAll, $visibleEvents }) => $seeAll ? `${$visibleEvents * 2 * 7}rem` : `${$visibleEvents * 7}rem`};
  overflow-y: ${({ $length, $visibleEvents }) => ($length > $visibleEvents ? 'auto' : 'visible')};
  margin-bottom: 1rem;
  
  ${({ $seeAll }) => $seeAll && `
    scrollbar-color: #fe2f67 #f0f0f0;
    
    /* Webkit scrollbar styles */
    &::-webkit-scrollbar {
      width: 0.5rem; /* Using rem units */
    }
    
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 0.25rem;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #fe2f67;
      border-radius: 0.25rem;
      border: none;
      box-shadow: none;
    }
  `}
`;

export const ShowMoreLink = styled.a`
  display: block;
  margin-top: 1.8rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  color: #fe2f67;
  cursor: pointer;
`;